import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetlinedetailReducer(state = initialState.budgetlinedetail, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETLINEDETAIL_SUCCESS:
      return action.budgetlinedetail;
    default:
      return state;
  }
}
